import React from "react";
import { p2pLedgerRowStatus } from "../../users/userP2PHelpers";
import P2PDuelMatchup from "./P2PDuelMatchup";

function statusTone(tone) {
  return tone === "live" ? "live" : tone === "warn" ? "warn" : "muted";
}

export default function P2PFixtureBlock({
  duel,
  as = "span",
  compact = false,
  showLabel = false,
  logoSize,
  className = "",
}) {
  const rowStatus = p2pLedgerRowStatus(duel);
  const tone = statusTone(rowStatus.tone);

  return (
    <div className={`ap2p-fixture-block${className ? ` ${className}` : ""}`}>
      {showLabel ? <p className="ap2p-match-label">Match</p> : null}
      <div className="ap2p-fixture-line">
        <P2PDuelMatchup
          duel={duel}
          as={as}
          compact={compact}
          showLogos
          alignLeft
          logoSize={logoSize}
        />
        <span className={`amf-row-tag amf-row-tag-${tone} ap2p-fixture-duel-badge`}>
          {rowStatus.label}
        </span>
      </div>
    </div>
  );
}
